//import axios from "@/app/Axios";
import axios from '@/http/connection/axios';

class Login {

    async loginUser(user_email, user_password) {
        try {
            const response = await axios.post("/login", {
                email: user_email,
                password: user_password,
            });
            if (response.data.access_token === null) {
                return false;
            } else {
                localStorage.setItem("access_token", response.data.access_token);
                return true;
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                const errorData = error.response.data;
                return errorData;
            } else {
                console.error(error);
            }
        }
    }//loginUser

    async authVerification() {
        try {
            const response = await axios.post("/me");
            if (response.status === 200) {
                return true;
            }
        } catch (error) {
            console.log("ACCESO NO AUTORIZADO, DEBE INICIAR SESION");
        }
        return false;
    }

    async authMe() {
        try {
            const response = await axios.post("/me");
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }


    async logout() {
        try {
            const response = await (axios.post("/logout"));
            if(response.data.status){
                localStorage.removeItem("access_token");
            }
            return response.data;
        } catch (error) {
            console.log(error)
        }

    }//logut
    async userme() {
        try {
            const response = await axios.get("/user");
            console.log("Este es el usuario logueado", response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
    async userroleauth() {
        try {
            const response = await axios.get("/userandrole");
            console.log("Este es el usuario logueado", response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }


}


export default Login;

